import { render } from "./SchedulePatientPhotoModal.vue?vue&type=template&id=146960a8"
import script from "./SchedulePatientPhotoModal.vue?vue&type=script&lang=js"
export * from "./SchedulePatientPhotoModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__